import React, { useState } from 'react';
import './Helpdesk.css';

function Helpdesk() {
  // FAQ expand/collapse. Each of the 87 FAQ items (repeated across
  // responsive variants) gets its own id (faq1..faq87 in document order)
  // so open/closed state is independent per item and per variant. 42 of
  // them have real answer text fetched from the live site
  // (scallopprod.xyz/helpdesk); the rest just toggle the chevron/open
  // state with no answer paragraph yet until more content is provided.
  const [openFaqs, setOpenFaqs] = useState({});
  return (
    <div className="page-helpdesk">
      <div
        style={{
          position: 'absolute',
          width: 0,
          height: 0,
          overflow: 'hidden',
        }}
        aria-hidden="true"
      >
        <>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            id="svg187274485_472"
          >
            <path
              d="M2 12C2 17.5228 6.4772 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5229 2 12 2C6.4772 2 2 6.47715 2 12Z"
              stroke="black"
              strokeWidth={1.5}
              strokeMiterlimit={10}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M8.47126 13.2602L12.0013 9.74023L15.5312 13.2602"
              stroke="black"
              strokeWidth={1.5}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            id="svg-2032160236_829"
          >
            <path
              d="M13.5004 0.75V10.5C13.5004 10.6989 13.4214 10.8897 13.2807 11.0303C13.1401 11.171 12.9493 11.25 12.7504 11.25C12.5515 11.25 12.3607 11.171 12.2201 11.0303C12.0794 10.8897 12.0004 10.6989 12.0004 10.5V2.56031L1.28104 13.2806C1.14031 13.4214 0.94944 13.5004 0.750417 13.5004C0.551394 13.5004 0.360523 13.4214 0.219792 13.2806C0.0790615 13.1399 0 12.949 0 12.75C0 12.551 0.0790615 12.3601 0.219792 12.2194L10.9401 1.5H3.00042C2.8015 1.5 2.61074 1.42098 2.47009 1.28033C2.32943 1.13968 2.25042 0.948912 2.25042 0.75C2.25042 0.551088 2.32943 0.360322 2.47009 0.21967C2.61074 0.0790178 2.8015 0 3.00042 0H12.7504C12.9493 0 13.1401 0.0790178 13.2807 0.21967C13.4214 0.360322 13.5004 0.551088 13.5004 0.75Z"
              fill="#71717A"
            />
          </svg>
          <svg
            width="48"
            height="47"
            viewBox="0 0 48 47"
            fill="none"
            id="svg-705979310_561"
          >
            <path
              d="M47.9382 23.3454C47.9382 36.4095 37.037 47 23.9682 47C10.8994 47 0 36.4077 0 23.3454C0 10.283 10.9012 0 23.97 0C37.0389 0 47.94 10.2813 47.94 23.3454H47.9382Z"
              fill="url(#svg-705979310_561_paint0_linear_1441_10670)"
            />
            <defs>
              <linearGradient
                id="svg-705979310_561_paint0_linear_1441_10670"
                x1="45.0436"
                y1="3.13334"
                x2="-2.2064"
                y2="10.7229"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="0.48255" stopColor="#1C6BF5" />
                <stop offset="1" stopColor="#1E45B4" />
              </linearGradient>
            </defs>
          </svg>
          <svg
            width="20"
            height="24"
            viewBox="0 0 20 24"
            fill="none"
            id="svg-583340053_1609"
          >
            <path
              d="M18.802 19.7673H17.4382C17.1321 19.7673 16.8827 20.0157 16.8827 20.3224V20.4981C16.8827 20.8049 16.6332 21.0532 16.3273 21.0532H3.41402C2.92055 21.0532 2.67293 20.4555 3.02133 20.1061L8.46609 14.6627H17.1675C17.2223 14.6627 17.2684 14.5404 17.2684 14.3896V12.7614C17.2684 12.6107 17.2241 12.4883 17.1675 12.4883H10.6419L11.6909 11.44C11.9085 11.2236 11.9085 10.8725 11.6909 10.6543L10.626 9.59012H17.1657C17.2206 9.59012 17.2665 9.4678 17.2665 9.31693V7.68873C17.2665 7.53798 17.2223 7.41566 17.1657 7.41566H8.45027L7.73555 6.70079L6.84937 5.81402L4.45594 3.42137C4.10578 3.07192 4.3534 2.4742 4.84863 2.4742H16.3255C16.6315 2.4742 16.881 2.72259 16.881 3.02939V3.20493C16.881 3.51184 17.1304 3.76188 17.4364 3.76188H18.8003C19.1063 3.76188 19.3557 3.5136 19.3557 3.20681V0.555187C19.3557 0.248277 19.1063 0 18.8003 0H0.557226C0.249491 0 0.00175685 0.248277 0.00175685 0.555187V2.47067L0.00539012 2.4742L3.34687 5.81402L4.23305 6.70079L4.94777 7.41566H2.19C2.13516 7.41566 2.0891 7.53798 2.0891 7.68873V9.31693C2.0891 9.4678 2.1334 9.59012 2.19 9.59012H7.12172L8.1866 10.6543C8.40422 10.8707 8.40422 11.2218 8.1866 11.44L7.13766 12.4883H2.19C2.13516 12.4883 2.0891 12.6107 2.0891 12.7614V14.3896C2.0891 14.5404 2.1334 14.6627 2.19 14.6627H4.96371L0.162773 19.4622C0.0583591 19.5669 0 19.707 0 19.8542V22.9723C0 23.2791 0.249492 23.5275 0.555469 23.5275H18.8003C19.1063 23.5275 19.3557 23.2791 19.3557 22.9723V20.3207C19.3557 20.0139 19.1063 19.7655 18.8003 19.7655L18.802 19.7673Z"
              fill="white"
            />
          </svg>
          <svg
            width="6"
            height="8"
            viewBox="0 0 6 8"
            fill="none"
            id="svg-615147730_250"
          >
            <path
              d="M0 0H0.952739V3.52559L4.46836 0H5.81954L2.81836 2.91506L5.90274 7.23342H4.63125L2.10704 3.60443L0.952739 4.71234V7.23342H0V0Z"
              fill="black"
            />
          </svg>
          <svg
            width="6"
            height="8"
            viewBox="0 0 6 8"
            fill="none"
            id="svg-145844853_1010"
          >
            <path
              d="M3.23555 3.31385C3.69375 3.31385 4.05586 3.22197 4.32071 3.03808C4.58907 2.85431 4.72383 2.52273 4.72383 2.04344C4.72383 1.52809 4.5375 1.17688 4.16367 0.989703C3.96445 0.891238 3.69727 0.842005 3.36328 0.842005H0.976172V3.31385H3.23555ZM0 0H3.33868C3.88829 0 4.3418 0.0804881 4.69922 0.241346C5.37657 0.549901 5.71524 1.11942 5.71524 1.94991C5.71524 2.38325 5.62618 2.73775 5.44571 3.01352C5.26875 3.2893 5.02031 3.51078 4.69922 3.67822C4.98047 3.79314 5.19141 3.94412 5.33321 4.1313C5.47617 4.31836 5.55704 4.62198 5.57344 5.04216L5.60743 6.01224C5.61797 6.28801 5.64024 6.49317 5.67656 6.62771C5.73516 6.85754 5.84063 7.00523 5.99063 7.07091V7.23342H4.79297C4.76016 7.17103 4.73321 7.09054 4.71446 6.99208C4.69453 6.89361 4.67813 6.70326 4.66524 6.4209L4.60547 5.21453C4.5832 4.74183 4.40742 4.42505 4.08047 4.26419C3.89414 4.1756 3.60117 4.1313 3.20157 4.1313H0.976172V7.23342H0V0Z"
              fill="black"
            />
          </svg>
          <svg
            width="8"
            height="8"
            viewBox="0 0 8 8"
            fill="none"
            id="svg-1278467936_878"
          >
            <path
              d="M3.4868 0C4.76028 0 5.70316 0.410309 6.31547 1.23105C6.79347 1.87119 7.03242 2.69016 7.03242 3.68809C7.03242 4.76815 6.75902 5.66585 6.21234 6.38154C5.57063 7.2219 4.65551 7.64208 3.46711 7.64208C2.35723 7.64208 1.48476 7.27443 0.849608 6.53911C0.28324 5.83 0 4.93382 0 3.85059C0 2.8724 0.242345 2.03534 0.726798 1.33938C1.34883 0.4465 2.26887 0 3.4868 0ZM3.585 6.76565C4.44597 6.76565 5.068 6.45698 5.45109 5.83987C5.83746 5.21947 6.03059 4.50718 6.03059 3.70289C6.03059 2.85266 5.80793 2.16823 5.36274 1.64958C4.92071 1.13094 4.31508 0.871615 3.54575 0.871615C2.79926 0.871615 2.19023 1.12929 1.71879 1.64465C1.24734 2.15671 1.01168 2.91341 1.01168 3.91463C1.01168 4.71563 1.21301 5.39184 1.61566 5.94327C2.02172 6.49152 2.67808 6.76565 3.585 6.76565Z"
              fill="black"
            />
          </svg>
          <svg
            width="10"
            height="8"
            viewBox="0 0 10 8"
            fill="none"
            id="svg-1222474147_282"
          >
            <path
              d="M1.06066 0L2.42098 5.88417L4.05141 0H5.11219L6.74262 5.88417L8.10293 0H9.17356L7.27793 7.23342H6.25149L4.58672 1.23598L2.91211 7.23342H1.88578L0 0H1.06066Z"
              fill="black"
            />
          </svg>
          <svg
            width="6"
            height="8"
            viewBox="0 0 6 8"
            fill="none"
            id="svg-185008150_190"
          >
            <path
              d="M5.85375 0V0.861745H3.42281V7.23342H2.43082V0.861745H0V0H5.85375Z"
              fill="black"
            />
          </svg>
          <svg
            width="6"
            height="8"
            viewBox="0 0 6 8"
            fill="none"
            id="svg493993136_215"
          >
            <path
              d="M0 0H5.25961V0.886304H0.952734V3.0825H4.93547V3.91957H0.952734V6.37167H5.3332V7.23342H0V0Z"
              fill="black"
            />
          </svg>
          <svg
            width="6"
            height="8"
            viewBox="0 0 6 8"
            fill="none"
            id="svg-1085139225_208"
          >
            <path
              d="M0 0H1.15407L4.79789 5.85961V0H5.72602V7.23342H4.6309L0.933047 1.37875V7.23342H0V0Z"
              fill="black"
            />
          </svg>
          <svg
            width="13"
            height="18"
            viewBox="0 0 13 18"
            fill="none"
            id="svg-1767852044_607"
          >
            <path
              d="M6.42188 9.32868L9.02579 0H12.532L8.20431 12.4382C7.3711 14.8361 6.71133 16.3212 6.225 16.8937C5.73985 17.4738 4.76719 17.7639 3.30938 17.7639C3.01641 17.7639 2.78086 17.76 2.60391 17.7523C2.42578 17.7523 2.15977 17.7406 1.80469 17.7175V15.072L2.22188 15.0952C2.54532 15.1107 2.85469 15.0991 3.14766 15.0604C3.44063 15.0217 3.68789 14.9327 3.88828 14.7935C4.08047 14.662 4.2586 14.3874 4.42032 13.9697C4.59024 13.5521 4.65938 13.2968 4.62891 13.2039L0 0H3.66797L6.42188 9.32868Z"
              fill="black"
            />
          </svg>
          <svg
            width="12"
            height="14"
            viewBox="0 0 12 14"
            fill="none"
            id="svg1825421648_1004"
          >
            <path
              d="M11.7914 9.27063C11.707 10.0209 11.3168 10.7829 10.623 11.5564C9.54258 12.7862 8.03086 13.4012 6.08672 13.4012C4.48242 13.4012 3.0668 12.8829 1.83984 11.8465C0.61289 10.8099 0 9.12364 0 6.78762C0 4.5986 0.551956 2.91999 1.65469 1.75204C2.76563 0.583975 4.20469 0 5.9707 0C7.0207 0 7.96523 0.197283 8.80664 0.59173C9.64687 0.986178 10.3418 1.60893 10.8891 2.45974C11.3824 3.2101 11.7035 4.0803 11.85 5.07036C11.9344 5.65057 11.9695 6.486 11.9531 7.57663H3.32109C3.3668 8.84516 3.76407 9.73476 4.5129 10.2453C4.96758 10.5624 5.51602 10.7209 6.15587 10.7209C6.83555 10.7209 7.38633 10.5275 7.81055 10.1408C8.04258 9.93192 8.24649 9.64193 8.42461 9.27063H11.7914ZM8.52891 5.39525C8.47383 4.52117 8.20781 3.85988 7.72969 3.41126C7.25977 2.95489 6.67266 2.72659 5.9707 2.72659C5.20781 2.72659 4.61368 2.96641 4.18946 3.44604C3.77227 3.92556 3.50977 4.57533 3.40195 5.39525H8.52891Z"
              fill="black"
            />
          </svg>
          <svg
            width="12"
            height="13"
            viewBox="0 0 12 13"
            fill="none"
            id="svg-1693400435_567"
          >
            <path
              d="M5.91316 2.74985C4.79461 2.74985 4.02702 3.22549 3.61042 4.17701C3.39433 4.67979 3.2864 5.32181 3.2864 6.10307V12.9486H0V0.32477H3.18223V2.16964C3.60656 1.51986 4.00769 1.05198 4.38573 0.765747C5.0646 0.25521 5.92476 0 6.96621 0C8.27015 0 9.33421 0.344158 10.1604 1.03259C10.9936 1.71327 11.4096 2.84655 11.4096 4.43222V12.9486H8.03109V5.25601C8.03109 4.59072 7.94203 4.0803 7.76508 3.7244C7.44047 3.07474 6.82359 2.74985 5.91316 2.74985Z"
              fill="black"
            />
          </svg>
          <svg
            width="13"
            height="14"
            viewBox="0 0 13 14"
            fill="none"
            id="svg2087326323_897"
          >
            <path
              d="M11.2942 2.00725C12.3588 3.34546 12.8911 4.92736 12.8911 6.75284C12.8911 8.60923 12.3588 10.1989 11.2942 11.5216C10.2295 12.8365 8.61341 13.4941 6.44555 13.4941C4.2777 13.4941 2.66156 12.8365 1.59692 11.5216C0.532267 10.1989 0 8.60923 0 6.75284C0 4.92736 0.532267 3.34546 1.59692 2.00725C2.66156 0.669163 4.2777 0 6.44555 0C8.61341 0 10.2295 0.669163 11.2942 2.00725ZM6.43395 2.79627C5.46961 2.79627 4.72524 3.14054 4.20059 3.82897C3.68368 4.50965 3.42528 5.48431 3.42528 6.75284C3.42528 8.02137 3.68368 8.99991 4.20059 9.68834C4.72524 10.3768 5.46961 10.7209 6.43395 10.7209C7.39828 10.7209 8.13891 10.3768 8.65583 9.68834C9.17274 8.99991 9.43114 8.02137 9.43114 6.75284C9.43114 5.48431 9.17274 4.50965 8.65583 3.82897C8.13891 3.14054 7.39828 2.79627 6.43395 2.79627Z"
              fill="black"
            />
          </svg>
          <svg
            width="17"
            height="18"
            viewBox="0 0 17 18"
            fill="none"
            id="svg466797663_450"
          >
            <path
              d="M3.32109 17.1025H0V0H5.18425L8.2855 13.4476L11.3636 0H16.4899V17.1025H13.1688V5.53458C13.1688 5.20194 13.1727 4.73781 13.1804 4.1422C13.1882 3.53884 13.192 3.07474 13.192 2.74986L9.9634 17.1025H6.50344L3.29801 2.74986C3.29801 3.07474 3.30188 3.53884 3.30961 4.1422C3.31723 4.73781 3.32109 5.20194 3.32109 5.53458V17.1025Z"
              fill="black"
            />
          </svg>
          <svg
            width="13"
            height="18"
            viewBox="0 0 13 18"
            fill="none"
            id="svg1460150476_230"
          >
            <path
              d="M11.7686 9.63028H3.48317V14.0277H12.9258V17.1025H0V0H12.5092V3.02833H3.48317V6.65999H11.7686V9.63028Z"
              fill="black"
            />
          </svg>
          <svg
            width="699"
            height="196"
            viewBox="0 0 699 196"
            fill="none"
            id="svg-1137231340_6119"
          >
            <path
              d="M668.903 75.4492C685.462 75.4492 698.806 91.3256 699 111.098C699 111.195 699 111.39 699 111.488C699 111.682 699 111.877 699 111.975C698.806 131.747 685.462 147.623 668.903 147.623C668.027 147.623 667.15 147.623 666.176 147.526L666.079 147.428C659.163 146.649 653.904 140.805 653.904 133.792V129.604H647.865V137.299V147.623V162.501L626.826 177.72V111.488V75.4492H647.865V85.7737V93.4684H653.904V89.2801C653.904 82.2673 659.163 76.3258 666.079 75.5466H666.176C667.15 75.4492 668.027 75.4492 668.903 75.4492ZM662.767 126.585C671.144 126.682 677.962 119.864 677.962 111.488C677.962 103.208 671.144 96.3904 662.767 96.4878C654.683 96.5852 647.962 103.208 647.865 111.39V111.488C647.865 111.585 647.865 111.585 647.865 111.682C647.962 119.864 654.683 126.487 662.767 126.585Z"
              fill="#030319"
            />
            <path
              d="M583.064 75.4492C602.933 75.4492 619.102 91.6177 619.102 111.488C619.102 131.455 602.933 147.623 583.064 147.623C563.096 147.623 546.928 131.455 546.928 111.488C546.928 91.6177 563.096 75.4492 583.064 75.4492ZM583.064 126.585C591.343 126.585 598.063 119.864 598.063 111.488C598.063 103.208 591.343 96.4878 583.064 96.4878C574.687 96.4878 567.966 103.208 567.966 111.488C567.966 119.864 574.687 126.585 583.064 126.585Z"
              fill="#030319"
            />
            <path
              d="M488.334 147.623V60.5712L509.373 45.3523V147.623H488.334ZM518.431 147.623V58.9032L539.47 43.6843V147.623H518.431Z"
              fill="#030319"
            />
            <path
              d="M459.569 85.7737V75.4492H480.608V111.488V147.623H459.569V137.299V129.604H453.53V133.792C453.53 140.805 448.368 146.649 441.355 147.428H441.258C440.381 147.526 439.407 147.623 438.531 147.623C422.07 147.623 408.628 131.747 408.434 111.975C408.434 111.78 408.434 111.682 408.434 111.488C408.434 111.39 408.434 111.195 408.434 111C408.628 91.3255 422.07 75.4492 438.531 75.4492C439.407 75.4492 440.381 75.4492 441.258 75.5466H441.355C448.368 76.3258 453.53 82.2673 453.53 89.2801V93.4684H459.569V85.7737ZM459.569 111.682C459.569 111.585 459.569 111.585 459.569 111.488V111.39C459.472 103.208 452.848 96.5852 444.667 96.4878C436.29 96.3904 429.472 103.208 429.472 111.488C429.472 119.864 436.29 126.585 444.667 126.585C452.848 126.487 459.472 119.767 459.569 111.682Z"
              fill="#030319"
            />
            <path
              d="M365.433 96.4878C357.056 96.4878 350.336 103.208 350.336 111.488C350.336 119.864 357.056 126.585 365.433 126.585C371.569 126.585 376.926 122.883 379.166 117.526H400.984C398.159 134.571 383.257 147.623 365.433 147.623C345.465 147.623 329.297 131.455 329.297 111.488C329.297 91.6177 345.465 75.4492 365.433 75.4492C383.257 75.4492 398.159 88.4035 400.984 105.546H379.166C376.926 100.189 371.569 96.4878 365.433 96.4878Z"
              fill="#030319"
            />
            <path
              d="M281.603 66.6326C266.839 66.6326 260.844 71.4881 260.844 77.8003C260.844 89.745 321.687 81.7819 321.687 115.479C321.687 120.335 315.245 147.623 278.739 147.623C254.492 147.623 244.023 133.833 239.37 127.715L238.744 126.938L254.724 115.283C254.724 115.283 262.365 126.647 278.739 126.647C293.592 126.647 299.587 121.792 299.587 115.479C299.587 103.243 238.744 111.692 238.744 77.8003C238.744 72.9448 245.186 45.6566 281.603 45.6566C305.94 45.6566 316.408 59.4464 321.061 65.5644L321.687 66.3412L305.707 77.6162C305.707 77.6162 298.066 66.6326 281.603 66.6326Z"
              fill="#030319"
            />
            <ellipse
              cx="97.8957"
              cy="97.8954"
              rx="97.8957"
              ry="97.8954"
              fill="url(#svg-1137231340_6119_paint0_linear_1843_2573)"
            />
            <path
              d="M103.576 14.4118C115.249 13.8539 129.142 17.6986 139.282 23.2509C158.722 33.8511 173.055 51.8528 179.03 73.1714C184.904 94.1022 182.275 116.505 171.709 135.505C161.278 154.663 143.583 168.825 122.604 174.805C121.916 175 121.535 175.131 120.923 174.79C120.848 174.232 123.053 171.981 123.588 171.354C127.648 166.588 129.697 162.178 131.673 156.382C133.304 155.423 134.869 154.356 136.358 153.19C151.792 141.054 161.837 123.339 164.329 103.867C166.932 83.664 161.768 65.3031 149.385 49.2548C145.6 44.5826 141.241 40.4056 136.412 36.8219C127.789 30.443 117.883 26.3644 107.081 25.9036C100.34 25.6159 94.1717 26.5885 89.9416 32.5503C88.1358 35.1174 87.0577 38.1249 86.8214 41.2544C85.8581 52.6598 94.7935 61.1826 102.438 68.3351C106.731 72.3277 111.304 76.1609 115.634 80.1021C126.117 89.6427 137.49 100.106 139.627 114.873C140.71 122.355 139.833 129.826 137.214 136.929C136.785 138.093 136.144 140.229 135.444 141.211L135.214 141.233C134.907 140.566 134.342 137.129 134.064 136.042C133.36 133.295 132.371 130.526 131.084 127.972C123.12 112.161 107.759 101.092 95.0915 89.0304C83.0497 77.5651 70.841 66.3252 69.8719 48.4363C69.4109 39.9256 72.4487 31.2566 78.2811 25.0667C85.079 17.8519 93.8037 14.7104 103.576 14.4118Z"
              fill="white"
            />
            <path
              d="M91.5742 180.82C79.901 181.378 66.0082 177.534 55.8688 171.981C36.4285 161.381 22.0955 143.379 16.1206 122.061C10.246 101.13 12.8756 78.7274 23.4413 59.7273C33.8727 40.5694 51.5673 26.4075 72.5462 20.4273C73.234 20.2325 73.6158 20.1012 74.2273 20.442C74.3028 20.9998 72.097 23.2514 71.5628 23.8785C67.5026 28.6444 65.4533 33.0547 63.4777 38.8504C61.8468 39.8095 60.2815 40.8763 58.7919 42.042C43.3582 54.178 33.3134 71.8929 30.8211 91.3651C28.218 111.568 33.3828 129.929 45.765 145.977C49.5501 150.65 53.9092 154.827 58.7385 158.41C67.3615 164.789 77.2674 168.868 88.0694 169.329C94.8106 169.616 100.979 168.644 105.209 162.682C107.015 160.115 108.093 157.107 108.329 153.978C109.292 142.572 100.357 134.05 92.7125 126.897C88.4197 122.904 83.8462 119.071 79.5159 115.13C69.0339 105.589 57.6601 95.1262 55.5235 80.3593C54.4404 72.877 55.3169 65.4066 57.9365 58.3035C58.3658 57.1393 59.0062 55.0028 59.7064 54.0216L59.9363 53.9994C60.2437 54.6664 60.8081 58.1028 61.0866 59.1903C61.7902 61.9377 62.7798 64.7057 64.0662 67.2598C72.0303 83.0713 87.391 94.1406 100.059 106.202C112.101 117.667 124.309 128.907 125.278 146.796C125.739 155.307 122.702 163.976 116.869 170.165C110.071 177.38 101.347 180.522 91.5742 180.82Z"
              fill="white"
            />
            <defs>
              <linearGradient
                id="svg-1137231340_6119_paint0_linear_1843_2573"
                x1="97.8957"
                y1="0"
                x2="46.0375"
                y2="179.202"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#0F1AF1" />
                <stop offset="1" stopColor="#2E38F9" />
              </linearGradient>
            </defs>
          </svg>
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            id="svg-1839680863_948"
          >
            <path
              d="M9.90033 7.61699C10.967 7.66699 11.242 8.57533 11.2587 9.00033H12.7503C12.6837 7.35033 11.5087 6.34199 9.87533 6.34199C8.03366 6.34199 6.66699 7.50033 6.66699 10.117C6.66699 11.7337 7.44199 13.6503 9.86699 13.6503C11.717 13.6503 12.7087 12.2753 12.7337 11.192H11.242C11.217 11.6837 10.867 12.342 9.88366 12.392C8.79199 12.3587 8.33366 11.5087 8.33366 10.117C8.33366 7.70866 9.40033 7.63366 9.90033 7.61699ZM10.0003 1.66699C5.40033 1.66699 1.66699 5.40033 1.66699 10.0003C1.66699 14.6003 5.40033 18.3337 10.0003 18.3337C14.6003 18.3337 18.3337 14.6003 18.3337 10.0003C18.3337 5.40033 14.6003 1.66699 10.0003 1.66699ZM10.0003 16.667C6.32533 16.667 3.33366 13.6753 3.33366 10.0003C3.33366 6.32533 6.32533 3.33366 10.0003 3.33366C13.6753 3.33366 16.667 6.32533 16.667 10.0003C16.667 13.6753 13.6753 16.667 10.0003 16.667Z"
              fill="#666D80"
            />
          </svg>
        </>
      </div>
      <>
        {/*$*/}
        <div
          data-framer-root=""
          className="framer-o7ufT framer-rcOGl framer-bCjmN framer-6lXp4 framer-is8chn helpdesk-s1"
        >
          <div className="ssr-variant hidden-6h2jjf">
            <div
              className="framer-1agd1r5-container hidden-is8chn hidden-1s49y8w helpdesk-s2"
              data-framer-appear-id="1agd1r5"
            >
              <div
                className="framer-8MFL4 framer-15zawlh framer-v-15zawlh helpdesk-s3"
                data-framer-name="Desktop [Default Boxed]"
              >
                <header
                  className="framer-ooxjtq helpdesk-s4"
                  data-border="true"
                  data-framer-name="Main Area"
                >
                  <div
                    className="framer-p578i7 helpdesk-s5"
                    data-framer-name="Background [Default]"
                  />
                  <div
                    className="framer-pc27k4 helpdesk-s6"
                    data-framer-name="Background [Boxed Mini]"
                  />
                  <div className="framer-cjwofg" data-framer-name="Content">
                    {/*$*/}
                    <a className="framer-1jy87r1 framer-145ct8v" href="/">
                      <div
                        data-framer-component-type="SVG"
                        data-framer-name="Logo + Logo Type"
                        parentsize="0"
                        _constraints="[object Object]"
                        rotation="0"
                        shadows=""
                        className="framer-1hjthz helpdesk-s7"
                        aria-hidden="true"
                      />
                    </a>
                    {/*/$*/}
                    <nav className="framer-xe9vp0" data-framer-name="Nav">
                      <div
                        className="framer-1hg3ikx-container"
                        data-framer-name="Menu [Desktop]"
                        name="Menu [Desktop]"
                      >
                        <div
                          name="Menu [Desktop]"
                          className="framer-n0D3w framer-1itjusz framer-v-1itjusz helpdesk-s8"
                          data-framer-name="Menu"
                        >
                          {/*$*/}
                          <div className="framer-mquu2a-container">
                            {/*$*/}
                            <a
                              className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq helpdesk-s9"
                              data-framer-name="Menu Item Simple"
                              data-highlight="true"
                              href="/accounts"
                              tabIndex={0}
                            >
                              <div
                                className="framer-19g30xi helpdesk-s10 reveal"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text helpdesk-s11"
                                >
                                  Accounts{' '}
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          {/*$*/}
                          <div className="framer-1yixouk-container">
                            {/*$*/}
                            <a
                              className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq helpdesk-s9"
                              data-framer-name="Menu Item Simple"
                              data-highlight="true"
                              href="/scallop-pay"
                              tabIndex={0}
                            >
                              <div
                                className="framer-19g30xi helpdesk-s10 reveal"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text helpdesk-s11"
                                >
                                  Scallop Pay
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          {/*$*/}
                          <div className="framer-wi7xty-container">
                            {/*$*/}
                            <a
                              className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq helpdesk-s9"
                              data-framer-name="Menu Item Simple"
                              data-highlight="true"
                              href="/cards"
                              tabIndex={0}
                            >
                              <div
                                className="framer-19g30xi helpdesk-s10 reveal"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text helpdesk-s11"
                                >
                                  Cards
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          {/*$*/}
                          <div className="framer-1tpzm7c-container">
                            {/*$*/}
                            <a
                              className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq helpdesk-s9"
                              data-framer-name="Menu Item Simple"
                              data-highlight="true"
                              href="/scallop-plus"
                              tabIndex={0}
                            >
                              <div
                                className="framer-19g30xi helpdesk-s10 reveal"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text helpdesk-s11"
                                >
                                  Scallop+
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          {/*$*/}
                          <div className="framer-u2qi4r-container">
                            {/*$*/}
                            <a
                              className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq helpdesk-s9"
                              data-framer-name="Menu Item Simple"
                              data-highlight="true"
                              href="/helpcenter"
                              data-framer-page-link-current="true"
                              tabIndex={0}
                            >
                              <div
                                className="framer-19g30xi helpdesk-s10 reveal"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text helpdesk-s11"
                                >
                                  FAQs
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                        </div>
                      </div>
                    </nav>
                    <div
                      className="framer-14uxsxw"
                      data-framer-name="Menu Icon"
                    >
                      <div
                        className="framer-16051d2"
                        data-framer-name="QR Overlay Trigger"
                        data-highlight="true"
                        tabIndex={0}
                      >
                        <div className="framer-168591e-container">
                          <div
                            className="framer-wWHmH framer-ly6l8a framer-v-18roq29 helpdesk-s12"
                            data-border="true"
                            data-framer-name="Variant 2"
                            data-highlight="true"
                            tabIndex={0}
                          >
                            <div
                              className="framer-1ebu3nm helpdesk-s13 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p
                                dir="auto"
                                className="framer-text helpdesk-s14"
                              >
                                Get Started
                              </p>
                            </div>
                            <div
                              className="framer-1u4w7ze helpdesk-s15 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p className="framer-text helpdesk-s16">
                                Coming soon
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </header>
              </div>
            </div>
          </div>
          <div className="ssr-variant hidden-1s49y8w hidden-is8chn">
            <div
              className="framer-1agd1r5-container hidden-is8chn hidden-1s49y8w"
              data-framer-appear-id="1agd1r5"
            >
              <div
                className="framer-8MFL4 framer-15zawlh framer-v-ewbo4l helpdesk-s3"
                data-framer-name="Mobile"
              >
                <header
                  className="framer-ooxjtq helpdesk-s17"
                  data-border="true"
                  data-framer-name="Main Area"
                >
                  <div
                    className="framer-p578i7 helpdesk-s5"
                    data-framer-name="Background [Default]"
                  />
                  <div
                    className="framer-pc27k4 helpdesk-s6"
                    data-framer-name="Background [Boxed Mini]"
                  />
                  <div className="framer-cjwofg" data-framer-name="Content">
                    {/*$*/}
                    <a className="framer-1jy87r1 framer-145ct8v" href="/">
                      <div
                        data-framer-component-type="SVG"
                        data-framer-name="Logo + Logo Type"
                        parentsize="0"
                        _constraints="[object Object]"
                        rotation="0"
                        shadows=""
                        className="framer-1hjthz helpdesk-s7"
                        aria-hidden="true"
                      />
                    </a>
                    {/*/$*/}
                    <nav className="framer-xe9vp0" data-framer-name="Nav" />
                    <div
                      className="framer-14uxsxw"
                      data-framer-name="Menu Icon"
                    >
                      <div className="framer-1yr51k6-container">
                        {/*$*/}
                        <div
                          className="framer-OuhX3 framer-1ib4qbi framer-v-1ib4qbi helpdesk-s18"
                          data-framer-name="Mobile Menu"
                          data-highlight="true"
                          tabIndex={0}
                        >
                          <div className="framer-1cux5of helpdesk-s19" />
                          <div className="framer-1w1bul6 helpdesk-s19" />
                          <div className="framer-1ku2ucf helpdesk-s20" />
                        </div>
                        {/*/$*/}
                      </div>
                    </div>
                  </div>
                </header>
              </div>
            </div>
          </div>
          <div className="ssr-variant hidden-1s49y8w">
            <div
              className="framer-1xw2z6v-container hidden-6h2jjf helpdesk-s2"
              data-framer-appear-id="1xw2z6v"
              id="1xw2z6v"
            >
              <div
                className="framer-8MFL4 framer-15zawlh framer-v-15zawlh helpdesk-s3"
                data-framer-name="Desktop [Default Boxed]"
              >
                <header
                  className="framer-ooxjtq helpdesk-s4"
                  data-border="true"
                  data-framer-name="Main Area"
                >
                  <div
                    className="framer-p578i7 helpdesk-s5"
                    data-framer-name="Background [Default]"
                  />
                  <div
                    className="framer-pc27k4 helpdesk-s6"
                    data-framer-name="Background [Boxed Mini]"
                  />
                  <div className="framer-cjwofg" data-framer-name="Content">
                    {/*$*/}
                    <a className="framer-1jy87r1 framer-145ct8v" href="/">
                      <div
                        data-framer-component-type="SVG"
                        data-framer-name="Logo + Logo Type"
                        parentsize="0"
                        _constraints="[object Object]"
                        rotation="0"
                        shadows=""
                        className="framer-1hjthz helpdesk-s7"
                        aria-hidden="true"
                      />
                    </a>
                    {/*/$*/}
                    <nav className="framer-xe9vp0" data-framer-name="Nav">
                      <div
                        className="framer-1hg3ikx-container"
                        data-framer-name="Menu [Desktop]"
                        name="Menu [Desktop]"
                      >
                        <div
                          name="Menu [Desktop]"
                          className="framer-n0D3w framer-1itjusz framer-v-1itjusz helpdesk-s8"
                          data-framer-name="Menu"
                        >
                          {/*$*/}
                          <div className="framer-mquu2a-container">
                            {/*$*/}
                            <a
                              className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq helpdesk-s9"
                              data-framer-name="Menu Item Simple"
                              data-highlight="true"
                              href="/accounts"
                              tabIndex={0}
                            >
                              <div
                                className="framer-19g30xi helpdesk-s10 reveal"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text helpdesk-s11"
                                >
                                  Accounts{' '}
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          {/*$*/}
                          <div className="framer-1yixouk-container">
                            {/*$*/}
                            <a
                              className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq helpdesk-s9"
                              data-framer-name="Menu Item Simple"
                              data-highlight="true"
                              href="/scallop-pay"
                              tabIndex={0}
                            >
                              <div
                                className="framer-19g30xi helpdesk-s10 reveal"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text helpdesk-s11"
                                >
                                  Scallop Pay
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          {/*$*/}
                          <div className="framer-wi7xty-container">
                            {/*$*/}
                            <a
                              className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq helpdesk-s9"
                              data-framer-name="Menu Item Simple"
                              data-highlight="true"
                              href="/cards"
                              tabIndex={0}
                            >
                              <div
                                className="framer-19g30xi helpdesk-s10 reveal"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text helpdesk-s11"
                                >
                                  Cards
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          {/*$*/}
                          <div className="framer-1tpzm7c-container">
                            {/*$*/}
                            <a
                              className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq helpdesk-s9"
                              data-framer-name="Menu Item Simple"
                              data-highlight="true"
                              href="/scallop-plus"
                              tabIndex={0}
                            >
                              <div
                                className="framer-19g30xi helpdesk-s10 reveal"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text helpdesk-s11"
                                >
                                  Scallop+
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          {/*$*/}
                          <div className="framer-u2qi4r-container">
                            {/*$*/}
                            <a
                              className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq helpdesk-s9"
                              data-framer-name="Menu Item Simple"
                              data-highlight="true"
                              href="/helpcenter"
                              data-framer-page-link-current="true"
                              tabIndex={0}
                            >
                              <div
                                className="framer-19g30xi helpdesk-s10 reveal"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text helpdesk-s11"
                                >
                                  FAQs
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                        </div>
                      </div>
                    </nav>
                    <div
                      className="framer-14uxsxw"
                      data-framer-name="Menu Icon"
                    >
                      <div
                        className="framer-16051d2"
                        data-framer-name="QR Overlay Trigger"
                        data-highlight="true"
                        tabIndex={0}
                      >
                        <div className="framer-168591e-container">
                          <div
                            className="framer-wWHmH framer-ly6l8a framer-v-18roq29 helpdesk-s12"
                            data-border="true"
                            data-framer-name="Variant 2"
                            data-highlight="true"
                            tabIndex={0}
                          >
                            <div
                              className="framer-1ebu3nm helpdesk-s13 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p
                                dir="auto"
                                className="framer-text helpdesk-s14"
                              >
                                Get Started
                              </p>
                            </div>
                            <div
                              className="framer-1u4w7ze helpdesk-s15 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p className="framer-text helpdesk-s16">
                                Coming soon
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </header>
              </div>
            </div>
          </div>
          <div className="ssr-variant hidden-6h2jjf hidden-is8chn">
            <div
              className="framer-1xw2z6v-container hidden-6h2jjf"
              data-framer-appear-id="1xw2z6v"
              id="1xw2z6v"
            >
              <div
                className="framer-8MFL4 framer-15zawlh framer-v-ewbo4l helpdesk-s3"
                data-framer-name="Mobile"
              >
                <header
                  className="framer-ooxjtq helpdesk-s17"
                  data-border="true"
                  data-framer-name="Main Area"
                >
                  <div
                    className="framer-p578i7 helpdesk-s5"
                    data-framer-name="Background [Default]"
                  />
                  <div
                    className="framer-pc27k4 helpdesk-s6"
                    data-framer-name="Background [Boxed Mini]"
                  />
                  <div className="framer-cjwofg" data-framer-name="Content">
                    {/*$*/}
                    <a className="framer-1jy87r1 framer-145ct8v" href="/">
                      <div
                        data-framer-component-type="SVG"
                        data-framer-name="Logo + Logo Type"
                        parentsize="0"
                        _constraints="[object Object]"
                        rotation="0"
                        shadows=""
                        className="framer-1hjthz helpdesk-s7"
                        aria-hidden="true"
                      />
                    </a>
                    {/*/$*/}
                    <nav className="framer-xe9vp0" data-framer-name="Nav" />
                    <div
                      className="framer-14uxsxw"
                      data-framer-name="Menu Icon"
                    >
                      <div className="framer-1yr51k6-container">
                        {/*$*/}
                        <div
                          className="framer-OuhX3 framer-1ib4qbi framer-v-1ib4qbi helpdesk-s18"
                          data-framer-name="Mobile Menu"
                          data-highlight="true"
                          tabIndex={0}
                        >
                          <div className="framer-1cux5of helpdesk-s19" />
                          <div className="framer-1w1bul6 helpdesk-s19" />
                          <div className="framer-1ku2ucf helpdesk-s20" />
                        </div>
                        {/*/$*/}
                      </div>
                    </div>
                  </div>
                </header>
              </div>
            </div>
          </div>
          <div className="framer-f9dma2">
            <div
              className="framer-xtprge hidden-1s49y8w"
              data-framer-name="Hero Main"
              id="accounts"
            >
              <div
                className="framer-1fm7ag6"
                data-framer-name="Hero"
                id="1fm7ag6"
              >
                <div className="framer-1cr36hb" data-framer-name="Hero Text">
                  <div className="framer-1df21m7" data-framer-name="Text">
                    <div className="framer-fhwqzm">
                      <div
                        className="framer-4xy069 reveal"
                        data-framer-appear-id="4xy069"
                        data-framer-name="Heading"
                        data-framer-component-type="RichTextContainer"
                      >
                        <h1
                          className="framer-text framer-styles-preset-18sajzf helpdesk-s21"
                          data-styles-preset="nXmNeSqma"
                          dir="auto"
                        >
                          Faq
                        </h1>
                      </div>
                    </div>
                    <div
                      className="framer-1vgfh6p reveal"
                      data-framer-appear-id="1vgfh6p"
                      data-framer-name="Description"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text helpdesk-s22">
                        Need help? Start here.
                        <br className="framer-text" />
                        Browse answers to the most common questions about your
                        account and features.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="framer-10qxvb3" id="featuresnew">
              <div className="framer-1qr8xrc" data-framer-name="Features Card">
                <div className="framer-1loidnc-container hidden-1s49y8w hidden-6h2jjf">
                  <div
                    className="framer-zkenK framer-s8e6qs framer-v-s8e6qs helpdesk-s3"
                    data-framer-name="Desktop 01"
                  >
                    <div className="framer-1x47de1" data-framer-name="FAQ Item">
                      <div className="framer-w35p0p-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq1"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq1: !p["faq1"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq1"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                What is Scallop App?
                              </h5>
                            </div>
                            {openFaqs["faq1"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  Scallop is a global financial platform that allows you to store, send, receive, and manage money across multiple fiat currencies and digital assets within a single app.
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="framer-1cue37a-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq2"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq2: !p["faq2"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq2"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                Can I use Scallop for everyday spending?
                              </h5>
                            </div>
                            {openFaqs["faq2"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  Yes, you can use virtual cards for online and global payments, or Scallop Pay to pay with local QR code payment providers.
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="framer-1ksamwb-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq3"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq3: !p["faq3"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq3"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                Can I hold multiple currencies at the same time?
                              </h5>
                            </div>
                            {openFaqs["faq3"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  Yes, you can hold and manage up to 52 fiat currencies and digital assets in one account.
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="framer-19670b2-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq4"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq4: !p["faq4"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq4"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                Can I track my transactions?
                              </h5>
                            </div>
                            {openFaqs["faq4"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  Yes, all transactions can be viewed and monitored within the app in real time.
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="framer-16x9nqp-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq5"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq5: !p["faq5"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq5"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                Do I need to complete identity verification
                                (KYC)?
                              </h5>
                            </div>
                            {openFaqs["faq5"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  Yes, all users must complete KYC before accessing core features. You can preview the app before completing verification.

                                  The process takes around 3 minutes and requires one of the following documents:
                                  a passport, a national ID (non-US only), or a tax identification number such as an SSN or TIN.

                                  For more details, please refer to:
                                  https://docs.scallopx.com/details/requirements-for-individuals
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="framer-rttq9g-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq6"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq6: !p["faq6"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq6"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                Can I send and receive money internationally?
                              </h5>
                            </div>
                            {openFaqs["faq6"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  Yes, Scallop supports international payments depending on your tier and supported payment rails and currencies.
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="framer-1e2r391-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq7"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq7: !p["faq7"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq7"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                What types of cards does Scallop provide?
                              </h5>
                            </div>
                            {openFaqs["faq7"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  Scallop provides virtual Visa cards that can be used for online and global payments, as well as in-store purchases via Apple Pay and Google Pay.
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="framer-cumj8o-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq8"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq8: !p["faq8"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq8"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                Can I add my card to Apple Pay or Google Pay?
                              </h5>
                            </div>
                            {openFaqs["faq8"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  Yes, the Scallop virtual card can be added as a payment method to Apple Pay and Google Pay.
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="framer-tjjewo-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq9"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq9: !p["faq9"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq9"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                Can I manage my virtual card?
                              </h5>
                            </div>
                            {openFaqs["faq9"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  Yes, you can block, unblock, and manage your card settings directly from the app at any time.
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="framer-149dkdl-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq10"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq10: !p["faq10"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq10"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                Can I convert between currencies in the app?
                              </h5>
                            </div>
                            {openFaqs["faq10"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  Yes, Scallop allows you to swap between supported fiat currencies and digital assets instantly.
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="framer-a5vwmo-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq11"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq11: !p["faq11"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq11"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                What are the swap fees?
                              </h5>
                            </div>
                            {openFaqs["faq11"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  Fees depend on your tier, with lower fees applied to higher tiers.
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="framer-1t45jrl-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq12"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq12: !p["faq12"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq12"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                Can I top up my eSIM plan?
                              </h5>
                            </div>
                            {openFaqs["faq12"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  Yes, you can add data or extend validity at any time, even after expiry.
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="framer-1pk9vex-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq13"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq13: !p["faq13"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq13"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                What happens when my eSIM expires?
                              </h5>
                            </div>
                            {openFaqs["faq13"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  The eSIM remains on your device, but data services stop until you renew or purchase a new plan.
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="framer-2tsko1-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq14"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq14: !p["faq14"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq14"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                Do I earn interest on my balance?
                              </h5>
                            </div>
                            {openFaqs["faq14"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  Interest or yield is not currently available but is planned as a future feature, depending on your tier.
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="framer-cia9f5-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq15"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq15: !p["faq15"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq15"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                What happens if I send digital assets to the
                                wrong network?
                              </h5>
                            </div>
                            {openFaqs["faq15"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  Recovery is not guaranteed. You may need to contact support, and recovery may involve fees and delays.
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="framer-151m1e3" data-framer-name="FAQ Item">
                      <div className="framer-5ys50-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq16"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq16: !p["faq16"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq16"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                Who can use Scallop?
                              </h5>
                            </div>
                            {openFaqs["faq16"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  Both individuals and businesses can use Scallop. Individuals can manage personal finances, while businesses can handle payments, collections, and multi-currency operations.
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="framer-1qluml7-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq17"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq17: !p["faq17"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq17"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                Can I use Scallop while traveling?
                              </h5>
                            </div>
                            {openFaqs["faq17"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  Yes, Scallop is designed for global usage, including payments and connectivity via eSIM.
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="framer-6at7ur-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq18"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq18: !p["faq18"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq18"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                What happens if I forget my password?
                              </h5>
                            </div>
                            {openFaqs["faq18"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  You do not need a password. You can sign in using your email address.

                                  For more details, please refer to:
                                  How to Sign Up
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="framer-1dqcytp-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq19"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq19: !p["faq19"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq19"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                Is Scallop available in my country?
                              </h5>
                            </div>
                            {openFaqs["faq19"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  Scallop supports onboarding across 120+ regions, with some exclusions due to international sanctions or regulatory limitations.

                                  A full list of prohibited countries & regions can be viewed here:
                                  https://docs.scallopx.com/details/onboarding-regions
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="framer-1xqh5zq-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq20"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq20: !p["faq20"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq20"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                Do I need to provide proof of address?
                              </h5>
                            </div>
                            {openFaqs["faq20"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  Proof of address is required only in specific cases, such as regulatory checks or additional verification requirements.
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="framer-1ua9vf5-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq21"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq21: !p["faq21"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq21"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                How long do money transfers take?
                              </h5>
                            </div>
                            {openFaqs["faq21"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  Transfer times vary by country and payment method. Some transfers are instant, while others may take longer depending on the payment rail.
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="framer-ykt5cs-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq22"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq22: !p["faq22"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq22"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                How much do virtual cards cost?
                              </h5>
                            </div>
                            {openFaqs["faq22"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  Pricing depends on your tier:

                                  Voyager: $2 per card

                                  Mariner: First card free, additional cards at a small fee

                                  Admiral: Multiple cards included at no additional cost
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="framer-1ac4ofd-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq23"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq23: !p["faq23"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq23"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                Can I withdraw funds from a virtual card?
                              </h5>
                            </div>
                            {openFaqs["faq23"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  No, funds loaded onto a virtual card are reserved for spending and cannot be withdrawn or reversed.
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="framer-pm1bko-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq24"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq24: !p["faq24"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq24"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                Is a passport mandatory?
                              </h5>
                            </div>
                            {openFaqs["faq24"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  A passport may be required for certain features, such as virtual card issuance, if not already provided during onboarding.
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="framer-1bcqg9y-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq25"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq25: !p["faq25"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq25"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                Can I reverse a swap transaction?
                              </h5>
                            </div>
                            {openFaqs["faq25"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  No, all swaps are final once confirmed.
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="framer-5a2h0r-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq26"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq26: !p["faq26"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq26"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                What is Scallop+ eSIM?
                              </h5>
                            </div>
                            {openFaqs["faq26"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  Scallop+ eSIM is a built-in digital SIM service that provides mobile data access across multiple countries without a physical SIM card.

                                  For more details, please refer to:
                                  https://docs.scallopx.com/details/scallop+-esim
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="framer-s6d4du-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq27"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq27: !p["faq27"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq27"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                Can I reuse a deleted eSIM?
                              </h5>
                            </div>
                            {openFaqs["faq27"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  No, once deleted, the eSIM cannot be reused or restored.
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="framer-1uyw215-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq28"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq28: !p["faq28"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq28"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                Is my money safe on Scallop?
                              </h5>
                            </div>
                            {openFaqs["faq28"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  Scallop applies security controls, compliance checks, and monitoring to protect user funds and transactions.
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="framer-17964iw-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq29"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq29: !p["faq29"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq29"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                How can I contact support?
                              </h5>
                            </div>
                            {openFaqs["faq29"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  You can reach support directly through the app or by email at support@scallop.zohodesk.eu
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="framer-f4s0zj-container">
                      {/*$*/}
                      <div />
                      {/*/$*/}
                    </div>
                  </div>
                </div>
                <div
                  className="framer-7a3hk6 hidden-is8chn hidden-6h2jjf"
                  data-framer-name="Desktop 01"
                >
                  <div className="framer-gwlstx" data-framer-name="FAQ Item">
                    <div className="ssr-variant">
                      <div className="framer-3nbe1l-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq30"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq30: !p["faq30"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq30"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                What is Scallop App?
                              </h5>
                            </div>
                            {openFaqs["faq30"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  Scallop is a global financial platform that allows you to store, send, receive, and manage money across multiple fiat currencies and digital assets within a single app.
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="ssr-variant">
                      <div className="framer-ufhsyn-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq31"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq31: !p["faq31"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq31"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                Can I use Scallop for everyday spending?
                              </h5>
                            </div>
                            {openFaqs["faq31"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  Yes, you can use virtual cards for online and global payments, or Scallop Pay to pay with local QR code payment providers.
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="ssr-variant">
                      <div className="framer-zfnhmm-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq32"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq32: !p["faq32"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq32"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                Can I hold multiple currencies at the same time?
                              </h5>
                            </div>
                            {openFaqs["faq32"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  Yes, you can hold and manage up to 52 fiat currencies and digital assets in one account.
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="ssr-variant">
                      <div className="framer-1if8jeq-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq33"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq33: !p["faq33"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq33"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                Can I track my transactions?
                              </h5>
                            </div>
                            {openFaqs["faq33"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  Yes, all transactions can be viewed and monitored within the app in real time.
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="ssr-variant">
                      <div className="framer-1m4nt73-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq34"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq34: !p["faq34"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq34"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                Do I need to complete identity verification
                                (KYC)?
                              </h5>
                            </div>
                            {openFaqs["faq34"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  Yes, all users must complete KYC before accessing core features. You can preview the app before completing verification.

                                  The process takes around 3 minutes and requires one of the following documents:
                                  a passport, a national ID (non-US only), or a tax identification number such as an SSN or TIN.

                                  For more details, please refer to:
                                  https://docs.scallopx.com/details/requirements-for-individuals
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="ssr-variant">
                      <div className="framer-1t5el8i-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq35"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq35: !p["faq35"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq35"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                Can I send and receive money internationally?
                              </h5>
                            </div>
                            {openFaqs["faq35"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  Yes, Scallop supports international payments depending on your tier and supported payment rails and currencies.
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="ssr-variant">
                      <div className="framer-1ivd5ef-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq36"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq36: !p["faq36"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq36"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                What types of cards does Scallop provide?
                              </h5>
                            </div>
                            {openFaqs["faq36"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  Scallop provides virtual Visa cards that can be used for online and global payments, as well as in-store purchases via Apple Pay and Google Pay.
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="ssr-variant">
                      <div className="framer-19qcbwk-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq37"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq37: !p["faq37"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq37"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                Can I add my card to Apple Pay or Google Pay?
                              </h5>
                            </div>
                            {openFaqs["faq37"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  Yes, the Scallop virtual card can be added as a payment method to Apple Pay and Google Pay.
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="ssr-variant">
                      <div className="framer-zg0dw5-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq38"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq38: !p["faq38"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq38"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                Can I manage my virtual card?
                              </h5>
                            </div>
                            {openFaqs["faq38"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  Yes, you can block, unblock, and manage your card settings directly from the app at any time.
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="ssr-variant">
                      <div className="framer-hvldu9-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq39"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq39: !p["faq39"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq39"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                Can I convert between currencies in the app?
                              </h5>
                            </div>
                            {openFaqs["faq39"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  Yes, Scallop allows you to swap between supported fiat currencies and digital assets instantly.
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="ssr-variant">
                      <div className="framer-ceuu7h-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq40"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq40: !p["faq40"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq40"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                What are the swap fees?
                              </h5>
                            </div>
                            {openFaqs["faq40"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  Fees depend on your tier, with lower fees applied to higher tiers.
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="ssr-variant">
                      <div className="framer-3oti59-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq41"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq41: !p["faq41"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq41"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                Can I top up my eSIM plan?
                              </h5>
                            </div>
                            {openFaqs["faq41"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  Yes, you can add data or extend validity at any time, even after expiry.
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="ssr-variant">
                      <div className="framer-p5fneb-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq42"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq42: !p["faq42"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq42"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                What happens when my eSIM expires?
                              </h5>
                            </div>
                            {openFaqs["faq42"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  The eSIM remains on your device, but data services stop until you renew or purchase a new plan.
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="ssr-variant">
                      <div className="framer-1lxvii3-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq43"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq43: !p["faq43"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq43"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                Do I earn interest on my balance?
                              </h5>
                            </div>
                            {openFaqs["faq43"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  Interest or yield is not currently available but is planned as a future feature, depending on your tier.
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="ssr-variant">
                      <div className="framer-9bk9ng-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq44"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq44: !p["faq44"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq44"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                What happens if I send digital assets to the
                                wrong network?
                              </h5>
                            </div>
                            {openFaqs["faq44"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  Recovery is not guaranteed. You may need to contact support, and recovery may involve fees and delays.
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="framer-1lwawdk" data-framer-name="FAQ Item">
                    <div className="ssr-variant">
                      <div className="framer-fqnmtb-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq45"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq45: !p["faq45"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq45"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                Who can use Scallop?
                              </h5>
                            </div>
                            {openFaqs["faq45"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  Both individuals and businesses can use Scallop. Individuals can manage personal finances, while businesses can handle payments, collections, and multi-currency operations.
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="ssr-variant">
                      <div className="framer-odh2nu-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq46"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq46: !p["faq46"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq46"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                Can I use Scallop while traveling?
                              </h5>
                            </div>
                            {openFaqs["faq46"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  Yes, Scallop is designed for global usage, including payments and connectivity via eSIM.
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="ssr-variant">
                      <div className="framer-1obuygj-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq47"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq47: !p["faq47"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq47"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                What happens if I forget my password?
                              </h5>
                            </div>
                            {openFaqs["faq47"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  You do not need a password. You can sign in using your email address.

                                  For more details, please refer to:
                                  How to Sign Up
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="ssr-variant">
                      <div className="framer-o8catf-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq48"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq48: !p["faq48"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq48"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                Is Scallop available in my country?
                              </h5>
                            </div>
                            {openFaqs["faq48"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  Scallop supports onboarding across 120+ regions, with some exclusions due to international sanctions or regulatory limitations.

                                  A full list of prohibited countries & regions can be viewed here:
                                  https://docs.scallopx.com/details/onboarding-regions
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="ssr-variant">
                      <div className="framer-1n5v44l-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq49"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq49: !p["faq49"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq49"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                Do I need to provide proof of address?
                              </h5>
                            </div>
                            {openFaqs["faq49"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  Proof of address is required only in specific cases, such as regulatory checks or additional verification requirements.
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="ssr-variant">
                      <div className="framer-6mfaqf-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq50"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq50: !p["faq50"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq50"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                How long do money transfers take?
                              </h5>
                            </div>
                            {openFaqs["faq50"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  Transfer times vary by country and payment method. Some transfers are instant, while others may take longer depending on the payment rail.
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="ssr-variant">
                      <div className="framer-14nfg2w-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq51"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq51: !p["faq51"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq51"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                How much do virtual cards cost?
                              </h5>
                            </div>
                            {openFaqs["faq51"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  Pricing depends on your tier:

                                  Voyager: $2 per card

                                  Mariner: First card free, additional cards at a small fee

                                  Admiral: Multiple cards included at no additional cost
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="ssr-variant">
                      <div className="framer-18e25w6-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq52"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq52: !p["faq52"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq52"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                Can I withdraw funds from a virtual card?
                              </h5>
                            </div>
                            {openFaqs["faq52"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  No, funds loaded onto a virtual card are reserved for spending and cannot be withdrawn or reversed.
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="ssr-variant">
                      <div className="framer-1rm2ae9-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq53"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq53: !p["faq53"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq53"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                Is a passport mandatory?
                              </h5>
                            </div>
                            {openFaqs["faq53"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  A passport may be required for certain features, such as virtual card issuance, if not already provided during onboarding.
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="ssr-variant">
                      <div className="framer-1ljcexn-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq54"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq54: !p["faq54"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq54"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                Can I reverse a swap transaction?
                              </h5>
                            </div>
                            {openFaqs["faq54"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  No, all swaps are final once confirmed.
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="ssr-variant">
                      <div className="framer-wdeigy-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq55"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq55: !p["faq55"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq55"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                What is Scallop+ eSIM?
                              </h5>
                            </div>
                            {openFaqs["faq55"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  Scallop+ eSIM is a built-in digital SIM service that provides mobile data access across multiple countries without a physical SIM card.

                                  For more details, please refer to:
                                  https://docs.scallopx.com/details/scallop+-esim
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="ssr-variant">
                      <div className="framer-x6uhrv-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq56"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq56: !p["faq56"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq56"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                Can I reuse a deleted eSIM?
                              </h5>
                            </div>
                            {openFaqs["faq56"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  No, once deleted, the eSIM cannot be reused or restored.
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="ssr-variant">
                      <div className="framer-daq99h-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq57"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq57: !p["faq57"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq57"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                Is my money safe on Scallop?
                              </h5>
                            </div>
                            {openFaqs["faq57"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  Scallop applies security controls, compliance checks, and monitoring to protect user funds and transactions.
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="ssr-variant">
                      <div className="framer-jyg9w8-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq58"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq58: !p["faq58"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq58"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                How can I contact support?
                              </h5>
                            </div>
                            {openFaqs["faq58"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  You can reach support directly through the app or by email at support@scallop.zohodesk.eu
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="framer-84o6cs-container">
                    {/*$*/}
                    <div />
                    {/*/$*/}
                  </div>
                </div>
                <div
                  className="framer-w3x51y hidden-is8chn hidden-1s49y8w"
                  data-framer-name="Desktop 01"
                >
                  <div className="framer-998elt" data-framer-name="FAQ Item">
                    <div className="ssr-variant">
                      <div className="framer-7jejgo-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq59"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq59: !p["faq59"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq59"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                What is Scallop App?
                              </h5>
                            </div>
                            {openFaqs["faq59"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  Scallop is a global financial platform that allows you to store, send, receive, and manage money across multiple fiat currencies and digital assets within a single app.
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="ssr-variant">
                      <div className="framer-tuohlj-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq60"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq60: !p["faq60"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq60"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                Can I use Scallop for everyday spending?
                              </h5>
                            </div>
                            {openFaqs["faq60"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  Yes, you can use virtual cards for online and global payments, or Scallop Pay to pay with local QR code payment providers.
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="ssr-variant">
                      <div className="framer-3kgron-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq61"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq61: !p["faq61"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq61"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                Can I hold multiple currencies at the same time?
                              </h5>
                            </div>
                            {openFaqs["faq61"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  Yes, you can hold and manage up to 52 fiat currencies and digital assets in one account.
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="ssr-variant">
                      <div className="framer-acf7f9-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq62"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq62: !p["faq62"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq62"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                Can I track my transactions?
                              </h5>
                            </div>
                            {openFaqs["faq62"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  Yes, all transactions can be viewed and monitored within the app in real time.
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="ssr-variant">
                      <div className="framer-1xwrr8q-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq63"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq63: !p["faq63"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq63"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                Do I need to complete identity verification
                                (KYC)?
                              </h5>
                            </div>
                            {openFaqs["faq63"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  Yes, all users must complete KYC before accessing core features. You can preview the app before completing verification.

                                  The process takes around 3 minutes and requires one of the following documents:
                                  a passport, a national ID (non-US only), or a tax identification number such as an SSN or TIN.

                                  For more details, please refer to:
                                  https://docs.scallopx.com/details/requirements-for-individuals
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="ssr-variant">
                      <div className="framer-jy4n57-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq64"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq64: !p["faq64"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq64"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                Can I send and receive money internationally?
                              </h5>
                            </div>
                            {openFaqs["faq64"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  Yes, Scallop supports international payments depending on your tier and supported payment rails and currencies.
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="ssr-variant">
                      <div className="framer-1qmw5cz-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq65"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq65: !p["faq65"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq65"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                What types of cards does Scallop provide?
                              </h5>
                            </div>
                            {openFaqs["faq65"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  Scallop provides virtual Visa cards that can be used for online and global payments, as well as in-store purchases via Apple Pay and Google Pay.
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="ssr-variant">
                      <div className="framer-lsi4r9-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq66"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq66: !p["faq66"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq66"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                Can I add my card to Apple Pay or Google Pay?
                              </h5>
                            </div>
                            {openFaqs["faq66"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  Yes, the Scallop virtual card can be added as a payment method to Apple Pay and Google Pay.
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="ssr-variant">
                      <div className="framer-1gz592-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq67"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq67: !p["faq67"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq67"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                Can I manage my virtual card?
                              </h5>
                            </div>
                            {openFaqs["faq67"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  Yes, you can block, unblock, and manage your card settings directly from the app at any time.
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="ssr-variant">
                      <div className="framer-10o9xtr-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq68"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq68: !p["faq68"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq68"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                Can I convert between currencies in the app?
                              </h5>
                            </div>
                            {openFaqs["faq68"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  Yes, Scallop allows you to swap between supported fiat currencies and digital assets instantly.
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="ssr-variant">
                      <div className="framer-1rb337n-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq69"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq69: !p["faq69"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq69"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                What are the swap fees?
                              </h5>
                            </div>
                            {openFaqs["faq69"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  Fees depend on your tier, with lower fees applied to higher tiers.
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="ssr-variant">
                      <div className="framer-1rsizvn-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq70"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq70: !p["faq70"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq70"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                Can I top up my eSIM plan?
                              </h5>
                            </div>
                            {openFaqs["faq70"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  Yes, you can add data or extend validity at any time, even after expiry.
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="ssr-variant">
                      <div className="framer-en71al-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq71"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq71: !p["faq71"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq71"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                What happens when my eSIM expires?
                              </h5>
                            </div>
                            {openFaqs["faq71"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  The eSIM remains on your device, but data services stop until you renew or purchase a new plan.
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="ssr-variant">
                      <div className="framer-1n5z2oj-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq72"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq72: !p["faq72"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq72"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                Do I earn interest on my balance?
                              </h5>
                            </div>
                            {openFaqs["faq72"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  Interest or yield is not currently available but is planned as a future feature, depending on your tier.
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="ssr-variant">
                      <div className="framer-7946mc-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq73"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq73: !p["faq73"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq73"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                What happens if I send digital assets to the
                                wrong network?
                              </h5>
                            </div>
                            {openFaqs["faq73"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  Recovery is not guaranteed. You may need to contact support, and recovery may involve fees and delays.
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="framer-1vgi261" data-framer-name="FAQ Item">
                    <div className="ssr-variant">
                      <div className="framer-1qn1p8c-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq74"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq74: !p["faq74"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq74"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                Who can use Scallop?
                              </h5>
                            </div>
                            {openFaqs["faq74"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  Both individuals and businesses can use Scallop. Individuals can manage personal finances, while businesses can handle payments, collections, and multi-currency operations.
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="ssr-variant">
                      <div className="framer-3ppu7-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq75"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq75: !p["faq75"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq75"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                Can I use Scallop while traveling?
                              </h5>
                            </div>
                            {openFaqs["faq75"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  Yes, Scallop is designed for global usage, including payments and connectivity via eSIM.
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="ssr-variant">
                      <div className="framer-1le16nq-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq76"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq76: !p["faq76"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq76"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                What happens if I forget my password?
                              </h5>
                            </div>
                            {openFaqs["faq76"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  You do not need a password. You can sign in using your email address.

                                  For more details, please refer to:
                                  How to Sign Up
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="ssr-variant">
                      <div className="framer-262aee-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq77"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq77: !p["faq77"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq77"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                Is Scallop available in my country?
                              </h5>
                            </div>
                            {openFaqs["faq77"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  Scallop supports onboarding across 120+ regions, with some exclusions due to international sanctions or regulatory limitations.

                                  A full list of prohibited countries & regions can be viewed here:
                                  https://docs.scallopx.com/details/onboarding-regions
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="ssr-variant">
                      <div className="framer-uyijt0-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq78"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq78: !p["faq78"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq78"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                Do I need to provide proof of address?
                              </h5>
                            </div>
                            {openFaqs["faq78"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  Proof of address is required only in specific cases, such as regulatory checks or additional verification requirements.
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="ssr-variant">
                      <div className="framer-dgcrpe-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq79"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq79: !p["faq79"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq79"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                How long do money transfers take?
                              </h5>
                            </div>
                            {openFaqs["faq79"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  Transfer times vary by country and payment method. Some transfers are instant, while others may take longer depending on the payment rail.
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="ssr-variant">
                      <div className="framer-1vf8v6h-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq80"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq80: !p["faq80"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq80"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                How much do virtual cards cost?
                              </h5>
                            </div>
                            {openFaqs["faq80"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  Pricing depends on your tier:

                                  Voyager: $2 per card

                                  Mariner: First card free, additional cards at a small fee

                                  Admiral: Multiple cards included at no additional cost
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="ssr-variant">
                      <div className="framer-qmbbw5-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq81"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq81: !p["faq81"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq81"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                Can I withdraw funds from a virtual card?
                              </h5>
                            </div>
                            {openFaqs["faq81"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  No, funds loaded onto a virtual card are reserved for spending and cannot be withdrawn or reversed.
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="ssr-variant">
                      <div className="framer-1ok1khg-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq82"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq82: !p["faq82"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq82"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                Is a passport mandatory?
                              </h5>
                            </div>
                            {openFaqs["faq82"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  A passport may be required for certain features, such as virtual card issuance, if not already provided during onboarding.
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="ssr-variant">
                      <div className="framer-qlg9zz-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq83"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq83: !p["faq83"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq83"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                Can I reverse a swap transaction?
                              </h5>
                            </div>
                            {openFaqs["faq83"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  No, all swaps are final once confirmed.
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="ssr-variant">
                      <div className="framer-1y9nk9i-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq84"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq84: !p["faq84"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq84"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                What is Scallop+ eSIM?
                              </h5>
                            </div>
                            {openFaqs["faq84"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  Scallop+ eSIM is a built-in digital SIM service that provides mobile data access across multiple countries without a physical SIM card.

                                  For more details, please refer to:
                                  https://docs.scallopx.com/details/scallop+-esim
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="ssr-variant">
                      <div className="framer-1x62xsq-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq85"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq85: !p["faq85"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq85"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                Can I reuse a deleted eSIM?
                              </h5>
                            </div>
                            {openFaqs["faq85"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  No, once deleted, the eSIM cannot be reused or restored.
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="ssr-variant">
                      <div className="framer-1qnsgyh-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq86"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq86: !p["faq86"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq86"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                Is my money safe on Scallop?
                              </h5>
                            </div>
                            {openFaqs["faq86"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  Scallop applies security controls, compliance checks, and monitoring to protect user funds and transactions.
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="ssr-variant">
                      <div className="framer-1kf2qe4-container">
                        <div
                          className="framer-QgOiN framer-11m97s5 framer-v-1en2rks helpdesk-s23"
                          data-border="true"
                          data-framer-name={openFaqs["faq87"] ? "Open" : "Close"}
                          data-highlight="true"
                          tabIndex={0}
                          onClick={() => setOpenFaqs((p) => ({ ...p, faq87: !p["faq87"] }))}
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-19pqi3p helpdesk-s24"
                            style={{ transform: openFaqs["faq87"] ? "none" : "rotate(180deg)" }}
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 24 24" className="helpdesk-s26">
                                <use href="#svg187274485_472" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-177uszz"
                            data-framer-name="Question & Answer"
                          >
                            <div
                              className="framer-q71sf2 helpdesk-s27 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <h5
                                dir="auto"
                                className="framer-text helpdesk-s28"
                              >
                                How can I contact support?
                              </h5>
                            </div>
                            {openFaqs["faq87"] && (
                              <div
                                className="framer-7zwq4t"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text">
                                  You can reach support directly through the app or by email at support@scallop.zohodesk.eu
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="framer-1fwxlbi-container">
                    {/*$*/}
                    <div />
                    {/*/$*/}
                  </div>
                </div>
              </div>
              <div
                className="framer-1rz91tr hidden-is8chn hidden-6h2jjf"
                data-framer-name="Hero"
                id="1rz91tr"
              >
                <div className="framer-wjwwkn" data-framer-name="Hero Text">
                  <div className="framer-rjf86o" data-framer-name="Text">
                    <div className="framer-1rvoo35">
                      <div
                        className="framer-qclxbl reveal"
                        data-framer-appear-id="qclxbl"
                        data-framer-name="Heading"
                        data-framer-component-type="RichTextContainer"
                      >
                        <h1
                          className="framer-text framer-styles-preset-18sajzf helpdesk-s21"
                          data-styles-preset="nXmNeSqma"
                          dir="auto"
                        >
                          Faq
                        </h1>
                      </div>
                    </div>
                    <div
                      className="framer-1f5n8ov reveal"
                      data-framer-appear-id="1f5n8ov"
                      data-framer-name="Description"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text helpdesk-s22">
                        Just pop your question below to get an answer.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="framer-6dbhe4" data-framer-name="Partners">
              <div className="framer-50wgwa" data-framer-name="Partners">
                <div className="framer-2z0oaw" data-framer-name="Image">
                  <div
                    data-framer-background-image-wrapper="true"
                    className="helpdesk-s29"
                  >
                    <img
                      decoding="async"
                      loading="lazy"
                      width="342"
                      height="450"
                      src="/framerusercontent.com/images/iW0wzRTnarXgbK1d0zeCWNI7Es.png"
                      alt=""
                      className="helpdesk-s30"
                    />
                  </div>
                </div>
                <div className="framer-1n6t2hm">
                  <div
                    className="framer-193w7wd helpdesk-s31 reveal"
                    data-framer-component-type="RichTextContainer"
                  >
                    <h6
                      className="framer-text framer-styles-preset-1hjmsm9"
                      data-styles-preset="ELMQsZX56"
                      dir="auto"
                    >
                      If you need more detailed information, visit our Scallop
                      Docs for a complete overview of all features and services.
                    </h6>
                  </div>
                  {/*$*/}
                  <a
                    className="framer-6k6agw framer-5il6z6"
                    href="https://docs.scallopx.com"
                    target="_blank"
                    rel="noopener"
                  >
                    <div
                      className="framer-ehavsr helpdesk-s31 reveal"
                      data-framer-name="Description"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text helpdesk-s32">
                        {/*$*/}
                        <span
                          className="framer-text framer-styles-preset-11r53mh"
                          data-styles-preset="LO9i42feF"
                          href="https://docs.scallopx.com/"
                          target="_blank"
                          rel="noopener"
                          data-nested-link="true"
                          role="link"
                          tabIndex={0}
                        >
                          Explore
                        </span>
                        {/*/$*/}
                      </p>
                    </div>
                    <div
                      className="framer-1c7s69g hidden-1s49y8w hidden-6h2jjf"
                      data-framer-name="ArrowUpRight"
                    >
                      <div
                        data-framer-component-type="SVG"
                        data-framer-name="Vector"
                        parentsize="0"
                        _constraints="[object Object]"
                        rotation="0"
                        shadows=""
                        className="framer-19fakg9 helpdesk-s33"
                        aria-hidden="true"
                      >
                        <div className="svgContainer helpdesk-s25">
                          <svg viewBox="0 0 14 14" className="helpdesk-s26">
                            <use href="#svg-2032160236_829" />
                          </svg>
                        </div>
                      </div>
                    </div>
                  </a>
                  {/*/$*/}
                </div>
                <div
                  className="framer-1vedex6 hidden-1s49y8w hidden-6h2jjf helpdesk-s34"
                  data-framer-name="image 1558"
                >
                  <div
                    data-framer-background-image-wrapper="true"
                    className="helpdesk-s29"
                  >
                    <img
                      decoding="async"
                      loading="lazy"
                      width="1024"
                      height="1024"
                      sizes="(min-width: 1440px) 240px, (min-width: 810px) and (max-width: 1439.98px) 240px, (max-width: 809.98px) 240px"
                      srcSet="/framerusercontent.com/images/s0JwQwODp3JsXtluVWbAxyxhbc.png 512w,/framerusercontent.com/images/s0JwQwODp3JsXtluVWbAxyxhbc.png 1024w"
                      src="/framerusercontent.com/images/s0JwQwODp3JsXtluVWbAxyxhbc.png"
                      alt=""
                      className="helpdesk-s30"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="framer-qvic8x" data-framer-name="Partners">
              <div className="framer-ez4yyv" data-framer-name="Partners">
                <div
                  className="framer-1p2heoj helpdesk-s31 reveal"
                  data-framer-name="Description"
                  data-framer-component-type="RichTextContainer"
                >
                  <p dir="auto" className="framer-text helpdesk-s32">
                    Our trusted partners
                  </p>
                </div>
                <div className="framer-we6mh8-container">
                  {/*$*/}
                  <section className="helpdesk-s35">
                    <div className="helpdesk-marquee-track">
                    <ul className="helpdesk-s36">
                      <li>
                        <div
                          className="framer-171mrlk helpdesk-s37"
                          data-framer-name="image 270"
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="helpdesk-s29"
                          >
                            <img
                              decoding="async"
                              width="492"
                              height="160"
                              src="/framerusercontent.com/images/ivSPK23J9RR1a4Hco5h0JeDko.png"
                              alt=""
                              className="helpdesk-s38"
                            />
                          </div>
                        </div>
                      </li>
                      <li>
                        <div
                          className="framer-1jqmsm5 helpdesk-s37"
                          data-framer-name="image 273"
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="helpdesk-s29"
                          >
                            <img
                              decoding="async"
                              width="480"
                              height="160"
                              src="/framerusercontent.com/images/moiOlfaGZqQcDQ2Z13c1uKUzPI.png"
                              alt=""
                              className="helpdesk-s38"
                            />
                          </div>
                          <div
                            className="framer-1wg2avz"
                            data-framer-name="Item \u2192 image 273 \u2192 moiOlfaGZqQcDQ2Z13c1uKUzPI.png"
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="helpdesk-s29"
                            >
                              <img
                                decoding="async"
                                width="480"
                                height="160"
                                src="/framerusercontent.com/images/VsSBYBESvevipPgqh18FJ54Fezw.png"
                                alt=""
                                className="helpdesk-s38"
                              />
                            </div>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div
                          className="framer-l33ibn helpdesk-s37"
                          data-framer-name="image 293"
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="helpdesk-s29"
                          >
                            <img
                              decoding="async"
                              width="548"
                              height="168"
                              sizes="(min-width: 1440px) 137px, (min-width: 810px) and (max-width: 1439.98px) 137px, (max-width: 809.98px) 137px"
                              srcSet="/framerusercontent.com/images/iIEMSIRUdZmveweRPf1nbqui87Y.png 512w,/framerusercontent.com/images/iIEMSIRUdZmveweRPf1nbqui87Y.png 548w"
                              src="/framerusercontent.com/images/iIEMSIRUdZmveweRPf1nbqui87Y.png"
                              alt=""
                              className="helpdesk-s38"
                            />
                          </div>
                        </div>
                      </li>
                      <li>
                        <div
                          className="framer-1ffvh36 helpdesk-s37"
                          data-framer-name="SWIFT logo.svg"
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="helpdesk-s29"
                          >
                            <img
                              decoding="async"
                              width="1280"
                              height="1280"
                              sizes="(min-width: 1440px) 139px, (min-width: 810px) and (max-width: 1439.98px) 139px, (max-width: 809.98px) 139px"
                              srcSet="/framerusercontent.com/images/km6jv13htIgnkxe33gYYSANahWY.png 512w,/framerusercontent.com/images/km6jv13htIgnkxe33gYYSANahWY.png 1024w,/framerusercontent.com/images/km6jv13htIgnkxe33gYYSANahWY.png 1280w"
                              src="/framerusercontent.com/images/km6jv13htIgnkxe33gYYSANahWY.png"
                              alt=""
                              className="helpdesk-s30"
                            />
                          </div>
                        </div>
                      </li>
                    </ul>
                    <ul className="helpdesk-s36" aria-hidden="true">
                      <li>
                        <div
                          className="framer-171mrlk helpdesk-s37"
                          data-framer-name="image 270"
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="helpdesk-s29"
                          >
                            <img
                              decoding="async"
                              width="492"
                              height="160"
                              src="/framerusercontent.com/images/ivSPK23J9RR1a4Hco5h0JeDko.png"
                              alt=""
                              className="helpdesk-s38"
                            />
                          </div>
                        </div>
                      </li>
                      <li>
                        <div
                          className="framer-1jqmsm5 helpdesk-s37"
                          data-framer-name="image 273"
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="helpdesk-s29"
                          >
                            <img
                              decoding="async"
                              width="480"
                              height="160"
                              src="/framerusercontent.com/images/moiOlfaGZqQcDQ2Z13c1uKUzPI.png"
                              alt=""
                              className="helpdesk-s38"
                            />
                          </div>
                          <div
                            className="framer-1wg2avz"
                            data-framer-name="Item \u2192 image 273 \u2192 moiOlfaGZqQcDQ2Z13c1uKUzPI.png"
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="helpdesk-s29"
                            >
                              <img
                                decoding="async"
                                width="480"
                                height="160"
                                src="/framerusercontent.com/images/VsSBYBESvevipPgqh18FJ54Fezw.png"
                                alt=""
                                className="helpdesk-s38"
                              />
                            </div>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div
                          className="framer-l33ibn helpdesk-s37"
                          data-framer-name="image 293"
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="helpdesk-s29"
                          >
                            <img
                              decoding="async"
                              width="548"
                              height="168"
                              sizes="(min-width: 1440px) 137px, (min-width: 810px) and (max-width: 1439.98px) 137px, (max-width: 809.98px) 137px"
                              srcSet="/framerusercontent.com/images/iIEMSIRUdZmveweRPf1nbqui87Y.png 512w,/framerusercontent.com/images/iIEMSIRUdZmveweRPf1nbqui87Y.png 548w"
                              src="/framerusercontent.com/images/iIEMSIRUdZmveweRPf1nbqui87Y.png"
                              alt=""
                              className="helpdesk-s38"
                            />
                          </div>
                        </div>
                      </li>
                      <li>
                        <div
                          className="framer-1ffvh36 helpdesk-s37"
                          data-framer-name="SWIFT logo.svg"
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="helpdesk-s29"
                          >
                            <img
                              decoding="async"
                              width="1280"
                              height="1280"
                              sizes="(min-width: 1440px) 139px, (min-width: 810px) and (max-width: 1439.98px) 139px, (max-width: 809.98px) 139px"
                              srcSet="/framerusercontent.com/images/km6jv13htIgnkxe33gYYSANahWY.png 512w,/framerusercontent.com/images/km6jv13htIgnkxe33gYYSANahWY.png 1024w,/framerusercontent.com/images/km6jv13htIgnkxe33gYYSANahWY.png 1280w"
                              src="/framerusercontent.com/images/km6jv13htIgnkxe33gYYSANahWY.png"
                              alt=""
                              className="helpdesk-s30"
                            />
                          </div>
                        </div>
                      </li>
                    </ul>
                    </div>
                  </section>
                  {/*/$*/}
                </div>
              </div>
            </div>
            <div className="framer-1b1xwr6">
              <div className="ssr-variant hidden-1s49y8w hidden-6h2jjf">
                <div className="framer-wnp8ll-container">
                  <div
                    className="framer-60Kb5 framer-1rilglu framer-v-1rilglu helpdesk-s40"
                    data-framer-name="Desktop"
                  >
                    <div
                      className="framer-14npji9"
                      data-framer-name="Frame 33595"
                    >
                      <div className="framer-1nbyyte">
                        <div
                          data-framer-component-type="SVG"
                          data-framer-name="Logo + Logo Type"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-1ick3k6 helpdesk-s33"
                          aria-hidden="true"
                        >
                          <div className="svgContainer helpdesk-s25">
                            <svg viewBox="0 0 699 196" className="helpdesk-s26">
                              <use href="#svg-1137231340_6119" />
                            </svg>
                          </div>
                        </div>
                        <div className="framer-6st60f">
                          <div
                            className="framer-9nwe5k helpdesk-s41 reveal"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text helpdesk-s42">
                              <strong className="framer-text">
                                One account for all your currencies{' '}
                                <br className="framer-text" />
                              </strong>
                              Manage, send, and receive money globally
                            </p>
                          </div>
                        </div>
                        <div
                          className="framer-1d0k7xa"
                          data-framer-name="ICO Logo_Blue"
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="helpdesk-s29"
                          >
                            <img
                              decoding="async"
                              width="1440"
                              height="1440"
                              sizes="(min-width: 1440px) 60px, (min-width: 810px) and (max-width: 1439.98px) 60px, (max-width: 809.98px) 60px"
                              srcSet="/framerusercontent.com/images/eFAqz3bGw0AvBGw3Cz1JaKPyTI.png 512w,/framerusercontent.com/images/eFAqz3bGw0AvBGw3Cz1JaKPyTI.png 1024w,/framerusercontent.com/images/eFAqz3bGw0AvBGw3Cz1JaKPyTI.png 1440w"
                              src="/framerusercontent.com/images/eFAqz3bGw0AvBGw3Cz1JaKPyTI.png"
                              alt=""
                              className="helpdesk-s30"
                            />
                          </div>
                        </div>
                        <div className="scallop-compliance-note">
                          <p>
                            This website is managed by Scallop Pvt Limited, Sri Lanka.
                            <br />
                            Scallop does not provide services in the countries listed on
                            its{' '}
                            <a
                              href="https://docs.scallopx.com/details/onboarding-regions"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Prohibited Countries list
                            </a>
                            .
                          </p>
                        </div>
                      </div>
                      <div
                        className="framer-c50yne"
                        data-framer-name="Frame 33594"
                      >
                        <div className="framer-5dec6k" data-framer-name="Menu">
                          <div
                            className="framer-nmphiu helpdesk-s43 reveal"
                            data-framer-name="Heading"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text helpdesk-s44">
                              Programs
                            </p>
                          </div>
                          <div
                            className="framer-1odpfed"
                            data-framer-name="List"
                          >
                            {/*$*/}
                            <div className="framer-1tz9h0j-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/ambassador"
                              >
                                <div
                                  className="framer-wlx7jb helpdesk-s43 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text helpdesk-s45">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/ambassador"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Ambassador
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                          </div>
                        </div>
                        <div className="framer-a8htgk" data-framer-name="Menu">
                          <div
                            className="framer-1rugbzn helpdesk-s43 reveal"
                            data-framer-name="Heading"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text helpdesk-s44">
                              Products
                            </p>
                          </div>
                          <div
                            className="framer-1oe4fxe"
                            data-framer-name="List"
                          >
                            {/*$*/}
                            <div className="framer-153yqwe-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/accounts"
                              >
                                <div
                                  className="framer-wlx7jb helpdesk-s43 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text helpdesk-s45">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/accounts"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Accounts
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            {/*$*/}
                            <div className="framer-1di1zw4-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/cards"
                              >
                                <div
                                  className="framer-wlx7jb helpdesk-s43 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text helpdesk-s45">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/cards"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Cards
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            {/*$*/}
                            <div className="framer-165n05h-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/scallop-pay"
                              >
                                <div
                                  className="framer-wlx7jb helpdesk-s43 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text helpdesk-s45">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/scallop-pay"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Scallop Pay
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            {/*$*/}
                            <div className="framer-1ddhrxh-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/scallop-plus"
                              >
                                <div
                                  className="framer-wlx7jb helpdesk-s43 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text helpdesk-s45">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/scallop-plus"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Scallop Plus
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            <div className="framer-nsl31k-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="https://blog.scallopx.com/"
                              >
                                <div
                                  className="framer-wlx7jb helpdesk-s43 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text helpdesk-s45">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="https://blog.scallopx.com/"
                                      rel="noopener"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Blogs
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                          </div>
                        </div>
                        <div className="framer-bcfdyi" data-framer-name="Menu">
                          <div
                            className="framer-cv5tks helpdesk-s43 reveal"
                            data-framer-name="Heading"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text helpdesk-s44">
                              Support
                            </p>
                          </div>
                          <div
                            className="framer-16j5a70"
                            data-framer-name="List"
                          >
                            {/*$*/}
                            <div className="framer-1apiy1v-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/support"
                              >
                                <div
                                  className="framer-wlx7jb helpdesk-s43 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text helpdesk-s45">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/support"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Contact Us
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            {/*$*/}
                            <div className="framer-650678-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/helpcenter"
                              >
                                <div
                                  className="framer-wlx7jb helpdesk-s43 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text helpdesk-s45">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/helpcenter"
                                      data-framer-page-link-current="true"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      FAQs
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            <div className="framer-1935128-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="https://docs.scallopx.com/"
                              >
                                <div
                                  className="framer-wlx7jb helpdesk-s43 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text helpdesk-s45">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="https://docs.scallopx.com/"
                                      rel="noopener"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Scallop Docs
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="framer-1l4w042"
                      data-framer-name="Frame 33831"
                    >
                      <div className="framer-jk8g5w" data-framer-name="Link">
                        <div className="framer-80yh0c">
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="ic:baseline-copyright"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-m3skko helpdesk-s33"
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 20 20" className="helpdesk-s26">
                                <use href="#svg-1839680863_948" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-hv1cvb helpdesk-s46 reveal"
                            data-framer-name="Item"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text helpdesk-s47">
                              2026 Scallop Group. All rights reserved.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="framer-1c28m8b">
                        {/*$*/}
                        <a
                          data-framer-component-type="SVG"
                          as="a"
                          data-framer-name="X"
                          href="https://x.com/Scallopcom"
                          target="_blank"
                          rel="noopener"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-dziac9 framer-1d3y7cu helpdesk-s48"
                          aria-hidden="true"
                        />
                        {/*/$*/}
                        {/*$*/}
                        <a
                          className="framer-n9nhin framer-1d3y7cu"
                          data-framer-name="LinkdIn"
                          href="https://www.linkedin.com/company/scallopcom"
                          target="_blank"
                          rel="noopener"
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="linkd"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-1ggemab helpdesk-s49"
                            aria-hidden="true"
                          />
                        </a>
                        {/*/$*/}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="ssr-variant hidden-6h2jjf hidden-is8chn">
                <div className="framer-wnp8ll-container">
                  <div
                    className="framer-60Kb5 framer-1rilglu framer-v-183e6ee helpdesk-s40"
                    data-framer-name="Tablet"
                  >
                    <div
                      className="framer-14npji9"
                      data-framer-name="Frame 33595"
                    >
                      <div className="framer-1nbyyte">
                        <div
                          data-framer-component-type="SVG"
                          data-framer-name="Logo + Logo Type"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-1ick3k6 helpdesk-s33"
                          aria-hidden="true"
                        >
                          <div className="svgContainer helpdesk-s25">
                            <svg viewBox="0 0 699 196" className="helpdesk-s26">
                              <use href="#svg-1137231340_6119" />
                            </svg>
                          </div>
                        </div>
                        <div className="framer-6st60f">
                          <div
                            className="framer-9nwe5k helpdesk-s41 reveal"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text helpdesk-s42">
                              <strong className="framer-text">
                                One account for all your currencies{' '}
                                <br className="framer-text" />
                              </strong>
                              Manage, send, and receive money globally
                            </p>
                          </div>
                        </div>
                        <div
                          className="framer-1d0k7xa"
                          data-framer-name="ICO Logo_Blue"
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="helpdesk-s29"
                          >
                            <img
                              decoding="async"
                              width="1440"
                              height="1440"
                              sizes="(min-width: 1440px) 60px, (min-width: 810px) and (max-width: 1439.98px) 60px, (max-width: 809.98px) 60px"
                              srcSet="/framerusercontent.com/images/eFAqz3bGw0AvBGw3Cz1JaKPyTI.png 512w,/framerusercontent.com/images/eFAqz3bGw0AvBGw3Cz1JaKPyTI.png 1024w,/framerusercontent.com/images/eFAqz3bGw0AvBGw3Cz1JaKPyTI.png 1440w"
                              src="/framerusercontent.com/images/eFAqz3bGw0AvBGw3Cz1JaKPyTI.png"
                              alt=""
                              className="helpdesk-s30"
                            />
                          </div>
                        </div>
                        <div className="scallop-compliance-note">
                          <p>
                            This website is managed by Scallop Pvt Limited, Sri Lanka.
                            <br />
                            Scallop does not provide services in the countries listed on
                            its{' '}
                            <a
                              href="https://docs.scallopx.com/details/onboarding-regions"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Prohibited Countries list
                            </a>
                            .
                          </p>
                        </div>
                      </div>
                      <div
                        className="framer-c50yne"
                        data-framer-name="Frame 33594"
                      >
                        <div className="framer-5dec6k" data-framer-name="Menu">
                          <div
                            className="framer-nmphiu helpdesk-s43 reveal"
                            data-framer-name="Heading"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text helpdesk-s44">
                              Programs
                            </p>
                          </div>
                          <div
                            className="framer-1odpfed"
                            data-framer-name="List"
                          >
                            {/*$*/}
                            <div className="framer-1tz9h0j-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/ambassador"
                              >
                                <div
                                  className="framer-wlx7jb helpdesk-s43 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text helpdesk-s45">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/ambassador"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Ambassador
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                          </div>
                        </div>
                        <div className="framer-a8htgk" data-framer-name="Menu">
                          <div
                            className="framer-1rugbzn helpdesk-s43 reveal"
                            data-framer-name="Heading"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text helpdesk-s44">
                              Products
                            </p>
                          </div>
                          <div
                            className="framer-1oe4fxe"
                            data-framer-name="List"
                          >
                            {/*$*/}
                            <div className="framer-153yqwe-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/accounts"
                              >
                                <div
                                  className="framer-wlx7jb helpdesk-s43 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text helpdesk-s45">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/accounts"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Accounts
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            {/*$*/}
                            <div className="framer-1di1zw4-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/cards"
                              >
                                <div
                                  className="framer-wlx7jb helpdesk-s43 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text helpdesk-s45">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/cards"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Cards
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            {/*$*/}
                            <div className="framer-165n05h-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/scallop-pay"
                              >
                                <div
                                  className="framer-wlx7jb helpdesk-s43 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text helpdesk-s45">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/scallop-pay"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Scallop Pay
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            {/*$*/}
                            <div className="framer-1ddhrxh-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/scallop-plus"
                              >
                                <div
                                  className="framer-wlx7jb helpdesk-s43 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text helpdesk-s45">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/scallop-plus"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Scallop Plus
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            <div className="framer-nsl31k-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="https://blog.scallopx.com/"
                              >
                                <div
                                  className="framer-wlx7jb helpdesk-s43 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text helpdesk-s45">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="https://blog.scallopx.com/"
                                      rel="noopener"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Blogs
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                          </div>
                        </div>
                        <div className="framer-bcfdyi" data-framer-name="Menu">
                          <div
                            className="framer-cv5tks helpdesk-s43 reveal"
                            data-framer-name="Heading"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text helpdesk-s44">
                              Support
                            </p>
                          </div>
                          <div
                            className="framer-16j5a70"
                            data-framer-name="List"
                          >
                            {/*$*/}
                            <div className="framer-1apiy1v-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/support"
                              >
                                <div
                                  className="framer-wlx7jb helpdesk-s43 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text helpdesk-s45">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/support"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Contact Us
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            {/*$*/}
                            <div className="framer-650678-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/helpcenter"
                              >
                                <div
                                  className="framer-wlx7jb helpdesk-s43 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text helpdesk-s45">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/helpcenter"
                                      data-framer-page-link-current="true"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      FAQs
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            <div className="framer-1935128-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="https://docs.scallopx.com/"
                              >
                                <div
                                  className="framer-wlx7jb helpdesk-s43 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text helpdesk-s45">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="https://docs.scallopx.com/"
                                      rel="noopener"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Scallop Docs
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="framer-1l4w042"
                      data-framer-name="Frame 33831"
                    >
                      <div className="framer-jk8g5w" data-framer-name="Link">
                        <div className="framer-80yh0c">
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="ic:baseline-copyright"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-m3skko helpdesk-s33"
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 20 20" className="helpdesk-s26">
                                <use href="#svg-1839680863_948" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-hv1cvb helpdesk-s46 reveal"
                            data-framer-name="Item"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text helpdesk-s47">
                              2026 Scallop Group. All rights reserved.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="framer-1c28m8b">
                        {/*$*/}
                        <a
                          data-framer-component-type="SVG"
                          as="a"
                          data-framer-name="X"
                          href="https://x.com/Scallopcom"
                          target="_blank"
                          rel="noopener"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-dziac9 framer-1d3y7cu helpdesk-s48"
                          aria-hidden="true"
                        />
                        {/*/$*/}
                        {/*$*/}
                        <a
                          className="framer-n9nhin framer-1d3y7cu"
                          data-framer-name="LinkdIn"
                          href="https://www.linkedin.com/company/scallopcom"
                          target="_blank"
                          rel="noopener"
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="linkd"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-1ggemab helpdesk-s49"
                            aria-hidden="true"
                          />
                        </a>
                        {/*/$*/}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="ssr-variant hidden-1s49y8w hidden-is8chn">
                <div className="framer-wnp8ll-container">
                  <div
                    className="framer-60Kb5 framer-1rilglu framer-v-ltf6f8 helpdesk-s40"
                    data-framer-name="Mobile"
                  >
                    <div
                      className="framer-14npji9"
                      data-framer-name="Frame 33595"
                    >
                      <div className="framer-1nbyyte">
                        <div
                          data-framer-component-type="SVG"
                          data-framer-name="Logo + Logo Type"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-1ick3k6 helpdesk-s33"
                          aria-hidden="true"
                        >
                          <div className="svgContainer helpdesk-s25">
                            <svg viewBox="0 0 699 196" className="helpdesk-s26">
                              <use href="#svg-1137231340_6119" />
                            </svg>
                          </div>
                        </div>
                        <div className="framer-6st60f">
                          <div
                            className="framer-9nwe5k helpdesk-s41 reveal"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text helpdesk-s42">
                              <strong className="framer-text">
                                One account for all your currencies{' '}
                                <br className="framer-text" />
                              </strong>
                              Manage, send, and receive money globally
                            </p>
                          </div>
                        </div>
                        <div
                          className="framer-1d0k7xa"
                          data-framer-name="ICO Logo_Blue"
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="helpdesk-s29"
                          >
                            <img
                              decoding="async"
                              width="1440"
                              height="1440"
                              sizes="(min-width: 1440px) 60px, (min-width: 810px) and (max-width: 1439.98px) 60px, (max-width: 809.98px) 60px"
                              srcSet="/framerusercontent.com/images/eFAqz3bGw0AvBGw3Cz1JaKPyTI.png 512w,/framerusercontent.com/images/eFAqz3bGw0AvBGw3Cz1JaKPyTI.png 1024w,/framerusercontent.com/images/eFAqz3bGw0AvBGw3Cz1JaKPyTI.png 1440w"
                              src="/framerusercontent.com/images/eFAqz3bGw0AvBGw3Cz1JaKPyTI.png"
                              alt=""
                              className="helpdesk-s30"
                            />
                          </div>
                        </div>
                        <div className="scallop-compliance-note">
                          <p>
                            This website is managed by Scallop Pvt Limited, Sri Lanka.
                            <br />
                            Scallop does not provide services in the countries listed on
                            its{' '}
                            <a
                              href="https://docs.scallopx.com/details/onboarding-regions"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Prohibited Countries list
                            </a>
                            .
                          </p>
                        </div>
                      </div>
                      <div
                        className="framer-c50yne"
                        data-framer-name="Frame 33594"
                      >
                        <div className="framer-5dec6k" data-framer-name="Menu">
                          <div
                            className="framer-nmphiu helpdesk-s43 reveal"
                            data-framer-name="Heading"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text helpdesk-s44">
                              Programs
                            </p>
                          </div>
                          <div
                            className="framer-1odpfed"
                            data-framer-name="List"
                          >
                            {/*$*/}
                            <div className="framer-1tz9h0j-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/ambassador"
                              >
                                <div
                                  className="framer-wlx7jb helpdesk-s43 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text helpdesk-s45">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/ambassador"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Ambassador
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                          </div>
                        </div>
                        <div className="framer-a8htgk" data-framer-name="Menu">
                          <div
                            className="framer-1rugbzn helpdesk-s43 reveal"
                            data-framer-name="Heading"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text helpdesk-s44">
                              Products
                            </p>
                          </div>
                          <div
                            className="framer-1oe4fxe"
                            data-framer-name="List"
                          >
                            {/*$*/}
                            <div className="framer-153yqwe-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/accounts"
                              >
                                <div
                                  className="framer-wlx7jb helpdesk-s43 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text helpdesk-s45">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/accounts"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Accounts
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            {/*$*/}
                            <div className="framer-1di1zw4-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/cards"
                              >
                                <div
                                  className="framer-wlx7jb helpdesk-s43 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text helpdesk-s45">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/cards"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Cards
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            {/*$*/}
                            <div className="framer-165n05h-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/scallop-pay"
                              >
                                <div
                                  className="framer-wlx7jb helpdesk-s43 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text helpdesk-s45">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/scallop-pay"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Scallop Pay
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            {/*$*/}
                            <div className="framer-1ddhrxh-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/scallop-plus"
                              >
                                <div
                                  className="framer-wlx7jb helpdesk-s43 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text helpdesk-s45">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/scallop-plus"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Scallop Plus
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            <div className="framer-nsl31k-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="https://blog.scallopx.com/"
                              >
                                <div
                                  className="framer-wlx7jb helpdesk-s43 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text helpdesk-s45">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="https://blog.scallopx.com/"
                                      rel="noopener"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Blogs
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                          </div>
                        </div>
                        <div className="framer-bcfdyi" data-framer-name="Menu">
                          <div
                            className="framer-cv5tks helpdesk-s43 reveal"
                            data-framer-name="Heading"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text helpdesk-s44">
                              Support
                            </p>
                          </div>
                          <div
                            className="framer-16j5a70"
                            data-framer-name="List"
                          >
                            {/*$*/}
                            <div className="framer-1apiy1v-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/support"
                              >
                                <div
                                  className="framer-wlx7jb helpdesk-s43 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text helpdesk-s45">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/support"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Contact Us
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            {/*$*/}
                            <div className="framer-650678-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/helpcenter"
                              >
                                <div
                                  className="framer-wlx7jb helpdesk-s43 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text helpdesk-s45">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/helpcenter"
                                      data-framer-page-link-current="true"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      FAQs
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            <div className="framer-1935128-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="https://docs.scallopx.com/"
                              >
                                <div
                                  className="framer-wlx7jb helpdesk-s43 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text helpdesk-s45">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="https://docs.scallopx.com/"
                                      rel="noopener"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Scallop Docs
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="framer-1l4w042"
                      data-framer-name="Frame 33831"
                    >
                      <div className="framer-jk8g5w" data-framer-name="Link">
                        <div className="framer-80yh0c">
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="ic:baseline-copyright"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-m3skko helpdesk-s33"
                            aria-hidden="true"
                          >
                            <div className="svgContainer helpdesk-s25">
                              <svg viewBox="0 0 20 20" className="helpdesk-s26">
                                <use href="#svg-1839680863_948" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-hv1cvb helpdesk-s46 reveal"
                            data-framer-name="Item"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text helpdesk-s47">
                              2026 Scallop Group. All rights reserved.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="framer-1c28m8b">
                        {/*$*/}
                        <a
                          data-framer-component-type="SVG"
                          as="a"
                          data-framer-name="X"
                          href="https://x.com/Scallopcom"
                          target="_blank"
                          rel="noopener"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-dziac9 framer-1d3y7cu helpdesk-s48"
                          aria-hidden="true"
                        />
                        {/*/$*/}
                        {/*$*/}
                        <a
                          className="framer-n9nhin framer-1d3y7cu"
                          data-framer-name="LinkdIn"
                          href="https://www.linkedin.com/company/scallopcom"
                          target="_blank"
                          rel="noopener"
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="linkd"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-1ggemab helpdesk-s49"
                            aria-hidden="true"
                          />
                        </a>
                        {/*/$*/}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="framer-1rk4glb-container">
            {/*$*/}
            {/*/$*/}
          </div>
        </div>
        <div id="overlay" />
        {/*/$*/}
      </>
    </div>
  );
}

export default Helpdesk;
